var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-editor-id":_vm.editor_id}},[_c('editor',{ref:"tiny",attrs:{"api-key":_vm.apikey,"init":_vm.config},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }